
import backIcon from '../../assets/icons/back.svg'
import infoIcon from '../../assets/icons/info.svg'
import reloadIcon from '../../assets/icons/reload.svg'

import './Button.css'

export default function Button( {icon, text, clickFunction, isOutlined = false, isBlock=false, isInverted=false} ) {

    let iconImg = null;
    let alt = "";
    
    switch (icon) {
        case 'BACK':
            iconImg = backIcon;
            alt= "back icon";
            break;
        case 'INFO':
            iconImg = infoIcon;
            alt= 'info icon';
            break;
        case 'RELOAD':
            iconImg = reloadIcon;
            alt= 'relaod icon';
            break;
        default:
            break;
    }

    const handleClick = (e) => {
        e.preventDefault()
        clickFunction()
    }

    return (
        <div className={`btn ${isOutlined ? 'outlined': ''} ${isBlock ? 'blocked' : ''}`} onClick={handleClick}>
            { iconImg && (
                <img src={iconImg} alt={alt} className={isInverted? 'inverted' : ''}/>
            )}
            { text && <span className='text-icon'>{text}</span>}
        </div>
    )
}
